import React from "react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import Breadcrumbs from "../components/Breadcrumbs";
import { useI18n } from "../i18n";
import { IMAGES, STATS } from "../mock";
import { Target, Eye, Award, Users } from "lucide-react";

export default function Company() {
  const { t } = useI18n();
  const values = [
    { icon: Target, t: { es: "Misión", en: "Mission" }, d: { es: "Suministrar equipos y servicios que optimicen las operaciones de nuestros clientes con calidad y cumplimiento.", en: "Supply equipment and services that optimize our clients' operations with quality and compliance." } },
    { icon: Eye, t: { es: "Visión", en: "Vision" }, d: { es: "Ser el aliado de referencia en suministro industrial binacional para la región andino-caribeña.", en: "To be the reference partner in binational industrial supply for the Andean-Caribbean region." } },
    { icon: Award, t: { es: "Valores", en: "Values" }, d: { es: "Integridad, compromiso, excelencia técnica y transparencia comercial.", en: "Integrity, commitment, technical excellence and commercial transparency." } },
    { icon: Users, t: { es: "Equipo", en: "Team" }, d: { es: "Ingenieros, especialistas comerciales y agentes de logística con experiencia comprobada.", en: "Engineers, commercial specialists and logistics agents with proven experience." } },
  ];
  return (
    <>
      <SEO title={{ es: "Empresa", en: "Company" }} path="/empresa" description={{ es: "Conozca Grupo Inversiones Altamira: misión, visión y trayectoria en suministro industrial.", en: "Learn about Grupo Inversiones Altamira: mission, vision and track record in industrial supply." }} />
      <section className="hero phero">
        <div className="bg" style={{ backgroundImage: `url(${IMAGES.heroCompany})` }} />
        <div className="shade" />
        <div className="container-x inner">
          <Breadcrumbs items={[{ label: { es: "Inicio", en: "Home" }, href: "/" }, { label: { es: "Empresa", en: "Company" } }]} />
          <span className="eyebrow">{t({ es: "Nuestra historia", en: "Our story" })}</span>
          <h1>{t({ es: "Suministro industrial con visión binacional", en: "Industrial supply with a binational vision" })}</h1>
        </div>
      </section>

      <section className="section">
        <div className="container-x" style={{ maxWidth: 880 }}>
          <Reveal>
            <p style={{ fontSize: 18, lineHeight: 1.8, color: "#354055" }}>{t({ es: "Grupo Inversiones Altamira C.A. nace en El Tigre, Anzoátegui, con el propósito de acercar a la industria latinoamericana los estándares y proveedores de primer nivel de Norteamérica. Con oficinas en Florida (EE. UU.) y Bogotá (Colombia), hoy suministramos y alquilamos equipos de bombeo, válvulas y cabezales de pozo, transformadores, estructuras de transmisión y equipos de protección personal a operadoras, contratistas y plantas industriales.", en: "Grupo Inversiones Altamira C.A. was born in El Tigre, Anzoátegui, with the purpose of bringing top-tier North American standards and suppliers to Latin American industry. With offices in Florida (USA) and Bogotá (Colombia), today we supply and rent pumping equipment, valves and wellheads, transformers, transmission structures and personal protective equipment to operators, contractors and industrial plants." })}</p>
          </Reveal>
        </div>
      </section>

      <section className="section" style={{ background: "var(--sand)", paddingTop: 40 }}>
        <div className="container-x">
          <div className="grid-4">
            {values.map((v, i) => (
              <Reveal key={i} delay={i * 80}>
                <div className="card" style={{ padding: 26 }}>
                  <div style={{ width: 48, height: 48, borderRadius: 10, background: "var(--gold)", display: "grid", placeItems: "center", color: "var(--navy)", marginBottom: 14 }}><v.icon size={22} /></div>
                  <h3 style={{ marginTop: 0 }}>{t(v.t)}</h3>
                  <p style={{ margin: 0, color: "#475066" }}>{t(v.d)}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="stats" style={{ marginTop: 60 }}>
            {STATS.map((s, i) => (<Reveal key={i} className="stat"><div className="n">{s.n}</div><div className="l">{t(s.label)}</div></Reveal>))}
          </div>
        </div>
      </section>
    </>
  );
}
